import { Tabs, Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useCommonStyles from '../../../useCommonStyles';
import { PurchaseOrSalesTransactionTabType } from '../../SaleTransactions';

export type MenuTabsProps = {
    a11yProps: (index: string) => object;
    value: PurchaseOrSalesTransactionTabType;
    setValue: (value: PurchaseOrSalesTransactionTabType) => void;
};

const MenuTabs = ({ value, setValue, a11yProps }: MenuTabsProps) => {
    const { t } = useTranslation(['transactionApprovalsPage']);
    const commonStyles = useCommonStyles();

    return (
        <Tabs
            classes={{ root: commonStyles.subMenusRoot, indicator: commonStyles.subMenusindicator }}
            indicatorColor="secondary"
            onChange={(event, value) => setValue(value)}
            scrollButtons="auto"
            textColor="secondary"
            value={value}
        >
            <Tab
                classes={{ root: commonStyles.subMenuTabRoot, selected: commonStyles.subMenuTabSelected }}
                label={t('transactionApprovalsPage:purchaseTransactions')}
                value="purchaseTransactions"
                {...a11yProps('purchaseTransactions')}
            />
            <Tab
                classes={{ root: commonStyles.subMenuTabRoot, selected: commonStyles.subMenuTabSelected }}
                label={t('transactionApprovalsPage:salesTransactions')}
                value="salesTransactions"
                {...a11yProps('salesTransactions')}
            />
        </Tabs>
    );
};

export default MenuTabs;
